module.exports = __webpack_public_path__ + "static/media/Fitmonkie_1.81e752b1.jpeg";